export const limitLines = (maxLines: number) => {
    return `
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: ${maxLines};
        -webkit-box-orient: vertical;
    `;
};